/**
 * @generated SignedSource<<26ead622436609eee5c259ff94662a71>>
 * @relayHash e99ed5b8b9cc1857aaf601b5016c29dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a75fea019aedf2450a61853684224cc6c3f13b92018ad510fa2b755507907ea3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_timelineQuery } from './src_timelineQuery.graphql';

import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: PreloadableConcreteRequest<src_timelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a75fea019aedf2450a61853684224cc6c3f13b92018ad510fa2b755507907ea3",
    "metadata": {},
    "name": "src_timelineQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};

export default node;
